<ng-container *ngIf="!!get">
    <div>
        <tt-card ttHeading="h_selection_criteria" class="col-xs-12 col-md-4 p-5">
            <tt-select ttLabel="portal_user_name" [(ttModel)]="get.portal_user_keyno" (ttModelChange)="loadTasks()" [ttData]="portalUsers" ttDataId="item_id" ttDataName="item_name"></tt-select>
        </tt-card>
        <tt-card ttHeading="h_functions" class="col-xs-12 col-md-4 p-5">
            <tt-button-goto ttText="timesheetdiary_new_today" ttIcon="far fa-plus" ttGoto="timeregister" [ttGotoParms]="{ custact_no: '0', powtime_keyno: '0' }"></tt-button-goto>
            <tt-button-settings *ngIf="get.show_setting === '1'" ttWebpageName="timesheetdiary"></tt-button-settings>
        </tt-card>
    </div>
    <tt-scheduler
        ttRememberId="timesheetdiary.scheduler"
        [(ttSelectedDate)]="get.date_fom"
        (ttSelectedDateChange)="loadTasks()"
        ttSelectedDateDebounceTime="250"
        [ttSelectedView]="get.selectedview"
        [ttData]="tasks"
        [ttResources]="owners"
        (ttSlotClick)="onSlotSelected($event)"
        (ttEventChange)="onEventChanged($event)"
        [ttShowRemoveButton]="false"
    ></tt-scheduler>
</ng-container>
